import { memo } from 'react';
import Card from '../../../component/card/Card.component';
import Grid from '@material-ui/core/Grid';
import GridComponentComponent from '../../../component/grid/GridComponent.component';
import FontBold from '../../../component/fontBold/FontBold.component';
import { LinkRouter } from '../../../component/link/Link';
import { ViewBody , Padding } from './cardComponent/Card';
import { BiCalendar, BiSad, BiMeh, BiSmile } from 'react-icons/bi';
import { AiFillEye} from 'react-icons/ai';
import ShortedFont from '../../../component/shortedFont/ShortedFont.component' ;
import Icons from './Icons.component';
import {Text} from '../../../container/store/details/assessment/component/ModalStyle';

interface CardBodyInterface {
  title: string;
  subTitle: string;
  score: number | string;
  date: string;
  assesment: string;
  store: string;
}

const CardBody = ({ title, date, subTitle, score, assesment, store }: CardBodyInterface) => {

  const renderNPS = (value:number|string) => {
    if(value >=0 && value <=6 )  {
      return <BiSad size={25} style={{ backgroundColor: '#F0F0F5', color:'#F52426', borderTopLeftRadius: 8, borderBottomLeftRadius: 8, padding: 10, marginRight: 10 }} />
    } else if(value >=7 && value <=8 ) {
      return <BiMeh size={25} style={{ backgroundColor: '#F0F0F5', color:'#c7a320', borderTopLeftRadius: 8, borderBottomLeftRadius: 8, padding: 10, marginRight: 10 }} />
    } else {
      return <BiSmile size={25} style={{ backgroundColor: '#F0F0F5', color:'#06981F', borderTopLeftRadius: 8, borderBottomLeftRadius: 8, padding: 10, marginRight: 10 }} />
    }
  }

  return (
    <>
    <Grid item xs={12} sm={6} md={4} lg={4} xl={2} >
      <Card color='#F0F0F5'>
        <Padding padding='10px 32px' >
          <FontBold title={title} isUpperCase={true} color='#3D3D4C' fontSize={22} />
          <ShortedFont subTitle={subTitle} isUpperCase={true} color='#3D3D4C' fontSize={16} />
        </Padding>
        <ViewBody>
          <GridComponentComponent justify='center' alignItems='flex-start' spacing={2} >
             <Icons>
              <Text>{store}</Text>
             </Icons>

            <Icons title={score}>
              { renderNPS(score)}
            </Icons>
            <Icons title={date} >
              <BiCalendar size={25} style={{ backgroundColor: '#F0F0F5', borderTopLeftRadius: 8, borderBottomLeftRadius: 8, padding: 10, marginRight: 10 }} />
            </Icons>
            <Grid item>
              <LinkRouter to={`/avaliacao-loja/avaliacao/${assesment}`} color='#3D3D4C'>
                <AiFillEye style={{ backgroundColor: '#FFF', borderRadius: 8, padding: 10 }} size={25} />
              </LinkRouter>
            </Grid>
          </GridComponentComponent>
        </ViewBody>
      </Card>
    </Grid>
    </>
  )
}

export default memo(CardBody);